import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import {Redirect, Route, Switch} from "react-router-dom";
import {withCookies} from "react-cookie";
import {connect} from 'react-redux';
import SweetAlert from "react-bootstrap-sweetalert";
import {deviceService} from '_services'

import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

import withStyles from "@material-ui/core/styles/withStyles";
import Header from "components/Header";
import Footer from "components/Footer";
import Sidebar from "components/Sidebar";
import dashboardRoutes from "routes/DashboardRoutes";

import appStyle from "./dashboardStyle.jsx";
import {deviceFleetActions, sweetAlertActions} from "_actions"
import logo from 'assets/logo/Logo_Octiva_WHITE_RGB_HR.png'
import logoMini from "assets/logo/Logo_Octiva_WHITE_RGB_no_text.png"
import {update_device_lists, update_error_codes} from "../views/helper_functions/device_icons";
import {
  update_deployment_list,
  update_greenhouse_list,
  update_location_list,
  update_map_list,
  update_organisation_list, update_partner_list
} from "../views/helper_functions/locations";
import {REFRESH_RATES, getRefreshRate} from "../_constants";
import {getUserType} from "../_services/authenticate";
import CustomInput from "../components/CustomInput";
import { verifyMFA, getUser, setupMFA } from "../_services/user.service.js"

let ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      sweet_alert: null,
      allRoutes: []
    };
    this.resizeFunction = this.resizeFunction.bind(this);
    this.timer = null
    this.fast_timer = null

    this.myMainPanelRef = React.createRef();

    this._is_mounted = false
    this._refresh_rate = REFRESH_RATES.VERY_SLOW
    this._fast_refresh_rate = REFRESH_RATES.SLOW
    // refresh to update is_live status
    // is_live is only correct up to 30 seconds, so we don't need to refresh more often than that
    this._refresh_device_state_rate = REFRESH_RATES._30_SEC 
  }

  componentDidMount() {
    this._is_mounted = true
    this.setState({loading: true})

    const {user} = this.props;

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.myMainPanelRef.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);

    const {dispatch} = this.props
    let device_serial = localStorage.getItem("selected_device_serial")
    if (device_serial !== null && device_serial !== undefined) {
      dispatch(deviceFleetActions.updateSerial(device_serial))
    }

    getUser(user.profile.username, res=>{
      if (!res.cognito_details.mfa_enabled){
        console.log("You need to enable MFA")
        this.update_mfa(user.profile.email)
      }
    }, error=>{
    })

    update_error_codes()
    update_organisation_list()
    update_partner_list()
    update_greenhouse_list()
    update_location_list()
    update_map_list()
    update_deployment_list()

    this.refresh()
    this.fast_refresh()
    this.refresh_device_state()
  }

  reOpenMFA() {
    const {dispatch, user} = this.props;
    this.handle_form_input_selector("device_name", null)
    this.handle_form_input_selector("totp_code", null)
    dispatch(sweetAlertActions.clear())
    this.update_mfa(user.profile.email)
  }

  verify_mfa(){
    const {totp_code, device_name} = this.state
    const {dispatch, user} = this.props
    
    // Client-side validation
    if (!device_name || !device_name.trim()) {
      this.display_mfa_fail({
        type: 'client_error',
        status: 422,
        message: 'Please enter a name for your MFA device'
      });
      return;
    }
    
    if (!totp_code || !totp_code.trim()) {
      this.display_mfa_fail({
        type: 'client_error',
        status: 422,
        message: 'Please enter your TOTP code from your authenticator app'
      });
      return;
    }
    
    if (totp_code.trim().length !== 6) {
      this.display_mfa_fail({
        type: 'client_error',
        status: 422,
        message: 'TOTP code must be 6 digits'
      });
      return;
    }
    
    verifyMFA(user.profile.email, totp_code, device_name, (data) => {
      // Success - both 200 and 204 responses will reach here
      dispatch(sweetAlertActions.success({
        title: "MFA is enabled",
      }))
    }, (error) => {
      console.error('MFA Verification Error:', error);
      // Error - non-2xx responses with error message extracted
      this.display_mfa_fail(error)
    })
  }

  display_mfa_fail(error) {
    const {dispatch} = this.props
    
    let title = "MFA Verification Failed";
    let userMessage = error.message || error;
    let showRetry = true;
    
    if (error.type === 'client_error') {
      // 400/422 errors - validation/user errors with reason codes
      const ERROR_MESSAGES = {
        'CODE_MISMATCH': 'The code you entered is incorrect. Please try again with a new code from your authenticator app.',
        'INVALID_REQUEST': 'Invalid request. Please ensure you have entered both a device name and a valid 6-digit code.'
      };
      
      if (error.status === 422) {
        title = "Validation Error";
        userMessage = error.message || "Please check your input and try again.";
      } else {
        userMessage = (error.reason && ERROR_MESSAGES[error.reason]) || error.message;
      }
    } else if (error.type === 'server_error') {
      // 500 errors - server errors
      title = "Server Error";
      userMessage = "There was an internal server error. Please contact the Cloud Team if the issue persists.";
      showRetry = true;
    }
    
    dispatch(sweetAlertActions.danger({
      title: title,
      closeOnClickOutside: false,
      confirmBtnText: showRetry ? "Retry" : "OK",
      onConfirm: () => {
        if (showRetry) {
          this.reOpenMFA();
        } else {
          dispatch(sweetAlertActions.clear());
        }
      },
      content: <div>
        <p>{userMessage}</p>
        {error.type === 'server_error' && <p style={{fontSize: '0.8em', color: '#999', marginTop: '10px'}}>Status: {error.status}</p>}
      </div>
    }))
  }

  handle_form_input_selector(name, value) {
    this.setState({[name]: value})
  }

  handle_key_up(textBoxId, key) {
    if (key === "Enter") {
      if (textBoxId === "totp_code") {
        const {dispatch} = this.props;
        dispatch(sweetAlertActions.clear())
        this.verify_mfa()
      } else {
        const nextELement = document.getElementById("totp_code")
        nextELement.focus()
      }
    }
  }

  update_mfa(email) {
    const {dispatch} = this.props

    setupMFA(email, data =>{
      const imageUrl = `data:image/svg+xml,${encodeURIComponent(data.qr_code_svg)}`;
      dispatch(sweetAlertActions.clean({
        title: "MFA is required",
        content: <div>
          <p>MFA is required for all Octiva employees, please enable with your authenticator app.</p>
          <p>Scan this QR code and enter the TOTP token.</p>
          <img src={imageUrl} alt="QR Code"/>
          <p>Don't have a QR code scanner? </p>
          <p>You can also enter the following code in your authenticator app: {data.secret_code}</p>

          <CustomInput
            id="device_name"
            labelText={"Required: Enter a name for your MFA Device"}
            inputProps={{
              onChange: event => this.handle_form_input_selector("device_name", event.target.value),
              type: "text",
              value: this.state["device_name"],
              onKeyUp: event => this.handle_key_up("device_name", event.key)
            }}
          />

          <CustomInput
            id="totp_code"
            labelText={"Required: Enter your TOTP Code"}
            inputProps={{
              onChange: event => this.handle_form_input_selector("totp_code", event.target.value),
              type: "text",
              value: this.state["totp_code"],
              onKeyUp: event => this.handle_key_up("totp_code", event.key)
            }}
          />
        </div>,
        onConfirm: this.verify_mfa.bind(this),
        closeOnClickOutside: false
      }))
    }, error => {
      this.display_mfa_fail(error)
    })
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    clearTimeout(this.fast_timer)
    this._is_mounted = false
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }

  refresh_device_state() {
    const {dispatch} = this.props
    dispatch(deviceFleetActions.fetchDeviceStateV2())

    const refreshRate = getRefreshRate(this._refresh_device_state_rate)
    if (this._is_mounted && refreshRate) {
      this.timer = setTimeout(() => this.refresh_device_state(), refreshRate)
    }
  }

  refresh() {
    update_device_lists()
    

    const refreshRate = getRefreshRate(this._refresh_rate)
    if (this._is_mounted && refreshRate) {
      this.timer = setTimeout(() => this.refresh(), refreshRate)
    }
  }

  fast_refresh() {
    const {all_devices, dispatch} = this.props

    if (!all_devices || all_devices.length === 0) {
      this.fast_timer = setTimeout(() => this.fast_refresh(), 1000) // Quick retry if no devices are available
      return
    }

    

    const refreshRate = getRefreshRate(this._fast_refresh_rate)
    if (this._is_mounted && refreshRate) {
      this.fast_timer = setTimeout(() => this.fast_refresh(), refreshRate)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location !== undefined && this.props.location !== undefined) {
      if (prevProps.location.pathname !== this.props.location.pathname) {
        this.myMainPanelRef.current.scrollTop = 0;
        if (this.state.mobileOpen) {
          this.setState({mobileOpen: false});
        }
      }
    }
  }

  handleDrawerToggle = () => {
    this.setState({mobileOpen: !this.state.mobileOpen});
  };

  sidebarMinimize() {
    this.setState({miniActive: !this.state.miniActive});
  }

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({mobileOpen: false});
    }
  }

  componentWillMount() {
    let newRoutes = [...dashboardRoutes.filter((route) => {
      if (route["roles"] !== undefined) {
        let user_type = getUserType()
        return route["roles"].includes(user_type)
      }
      return true
    })]

    newRoutes.push({
      redirect: true,
      path: "/",
      pathTo: newRoutes[0].path,
      name: newRoutes[0].name
    })
    this.setState({allRoutes: newRoutes})

  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.sweet_alert) {
      if (nextProps.sweet_alert.type) {
        this.showSweetAlert(nextProps.sweet_alert.type, nextProps.sweet_alert.options)
      } else {
        this.setState({
          sweet_alert: null
        });
      }
    }
  }

  showSweetAlert(type, options) {
    const {classes} = this.props
    this.setState({
      sweet_alert:
        <SweetAlert
          danger={type === 'sweet_alert-danger'}
          warning={type === 'sweet_alert-warning'}
          success={type === 'sweet_alert-success'}
          info={type === 'sweet_alert-info'}

          style={{display: "block", marginTop: "10px"}}
          title={options.title}

          onConfirm={options.onConfirm ? options.onConfirm.bind(this) : this.hideAlert.bind(this)}
          confirmBtnCssClass={classes ? classes.button + " " + classes.successBtn : ''}
          confirmBtnText={options.confirmBtnText}

          cancelBtnText={options.cancelBtnText}
          onCancel={options.onCancel ? options.onCancel.bind(this) : this.hideAlert.bind(this)}
          cancelBtnCssClass={classes ? classes.button : ''}

          showCancel={options.showCancel}
          closeOnClickOutside={options.closeOnClickOutside}
        >
          {options.content}
        </SweetAlert>
    })
  }

  hideAlert() {
    this.setState({
      sweet_alert: null
    });
    this.props.dispatch(sweetAlertActions.clear())
  }

  render() {
    const {classes, ...rest} = this.props;
    const {sweet_alert, allRoutes} = this.state;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1
      });

    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={this.state.allRoutes}
          logo={logo}
          logoMini={logoMini}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="primary"
          bgColor="black"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref={this.myMainPanelRef}>
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={this.state.allRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and container classes are present because they have some paddings which would make the map smaller */}
          <div className={classes.content}>
            <div className={classes.container}>
              <Switch>
                {allRoutes.map((prop, key) => {
                  if (prop.redirect)
                    return <Redirect from={prop.path} to={prop.pathTo} key={key}/>;
                  if (prop.collapse)
                    return prop.views.map((prop, key) => {
                      return (
                        <Route path={prop.path} component={prop.component} key={key}
                               hidden={prop.hidden}/>
                      );
                    });
                  return <Route path={prop.path} component={prop.component} key={key}/>;
                })}
              </Switch>
            </div>
          </div>
          <Footer fluid/>
          {sweet_alert}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {sweet_alert} = state;
  const {device_serial, all_devices} = state.device_fleet;
  const {user} = state.authentication
  return {
    sweet_alert, device_serial, all_devices, user
  }
}

export default withCookies(withStyles(appStyle)(connect(mapStateToProps)(Dashboard)))
